import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconUsers = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.5 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5M5.379 19C2.927 19 1 17.362 1 16.122c0-2.302.844-3.63 2.265-4.122.702.975 1.727 1.468 2.735 1.33-.418 1.054-.621 2.306-.621 3.724zM18.621 19C21.073 19 23 17.362 23 16.122c0-2.302-.844-3.63-2.265-4.122-.702.975-1.727 1.468-2.735 1.33.418 1.054.621 2.306.621 3.724zM5.5 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5M9.444 12a3.47 3.47 0 0 0 2.578 1.16c1.01 0 1.922-.442 2.57-1.15 1.511.43 2.408 1.565 2.408 3.523V20c-3.5 1.5-6.5 1.5-10 0v-4.467c0-1.973.91-3.11 2.444-3.533M12.027 10.652a3.27 3.27 0 0 1-3.268-3.27 3.27 3.27 0 1 1 6.535 0 3.27 3.27 0 0 1-3.267 3.27"
      clipRule="evenodd"
    />
  </NcIcon>
);
export { NcIconUsers };
